/**
 * Arquivo que define as mascaras com regex
 */

// utils
import { onlyNumbers, onlyAlphaNumeric } from '../utils';

// Aceita dígito ou letra maiúscula (CNPJ alfanumérico) — usado nos 12 primeiros
// dígitos do CNPJ. O regex de máscara já força uppercase via 'pipe' (ver abaixo).
const alfanumerico = /[A-Za-z0-9]/;

/**
 * Exporta a variação de mascaras entre CPF e CNPJ
 * OBS: CPF continua só numérico, então maskCpfCnpj não muda de lógica,
 * só o array do CNPJ é que muda internamente (maskCnpj).
 */
export const maskCpfCnpj = props => {
  const propsNumbers = onlyAlphaNumeric(props);
  return propsNumbers.length > 11 ? maskCnpj : maskCpf;
};

/**
 * Mascara CPF
 */
export const maskCpf = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];

/**
 * Mascara CNPJ — ATUALIZADA para suportar CNPJ alfanumérico
 * Os 12 primeiros caracteres aceitam letra ou número.
 * Os 2 últimos (DV) continuam exclusivamente numéricos.
 */
export const maskCnpj = [
  alfanumerico,
  alfanumerico,
  '.',
  alfanumerico,
  alfanumerico,
  alfanumerico,
  '.',
  alfanumerico,
  alfanumerico,
  alfanumerico,
  '/',
  alfanumerico,
  alfanumerico,
  alfanumerico,
  alfanumerico,
  '-',
  /\d/,
  /\d/,
];

/**
 * Mascara DATA
 */
export const maskDate = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

/**
 * Mascara TELEFONE
 */
export const maskPhone = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

/**
 * Mascara Celular
 */
export const maskCelPhone = props => {
  const value = props.replace(/[^\d]+/g, '');
  const lenght = value.split('').length;

  if (lenght < 11) {
    return [
      '(',
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  } else {
    return [
      '(',
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  }
};

/**
 * Mascara CEP
 */

export const cep = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];